import classes from "./InputErrorMessage.module.css";

const InputErrorMessage = (props) => (
  <span className={classes.errorMessage}>{props.children}</span>
);

export default InputErrorMessage;
